export const USER_DATA_SET = 'at/panels/user/USER_DATA_SET'
export const FULL_USER_INFO_SET = 'at/panels/user/FULL_USER_INFO_SET'
export const EXTENDED_DATA_UPDATE = 'at/panels/user/EXTENDED_DATA_UPDATE'
export const USER_GROUP_DATA_SET = 'at/panels/user/USER_GROUP_DATA_SET'
export const TIME_ZONE_GROUP_DATA_SET = 'at/panels/user/TIME_ZONE_GROUP_DATA_SET'
export const USER_MANAGE_ASSIGNMENTS_DATA_SET = 'at/panels/user/USER_MANAGE_ASSIGNMENTS_DATA_SET'
export const USER_MANAGEMENT_ASSIGNMENTS_SELECTION_SET = 'at/panels/user/USER_MANAGEMENT_ASSIGNMENTS_SELECTION_SET'
export const USER_TEAM_ASSIGNMENTS_DATA_SET = 'at/panels/user/USER_TEAM_ASSIGNMENTS_DATA_SET'
export const USER_PANEL_ERROR_ADD = 'at/panels/user/editPanel/USER_PANEL_ERROR_ADD'
export const USER_PANEL_PASSWORD_VALIDATION_RESULT_SET = 'at/panels/user/USER_PANEL_PASSWORD_VALIDATION_RESULT_SET'
export const USER_PANEL_ERRORS_SET = 'at/panels/user/editPanel/USER_PANEL_ERRORS_SET'
export const USER_PANEL_ERRORS_CLEAR = 'at/panels/user/editPanel/USER_PANEL_ERRORS_CLEAR'
export const USER_PANEL_ERRORS_REMOVE = 'at/panels/user/editPanel/USER_PANEL_ERRORS_REMOVE'
export const USER_PANEL_HAS_LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE_ERROR = 'at/panels/user/editPanel/USER_PANEL_HAS_LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE_ERROR'
export const ALL_APPROVERS_SET = 'at/panels/user/ALL_APPROVERS_SET'

export const MANAGEMENT_ASSIGNMENTS_COUNTS_LOADED_SET = 'at/panels/user/createPanel/MANAGEMENT_ASSIGNMENTS_COUNTS_LOADED_SET'

export const MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD = 'at/panels/user/createPanel/MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD'
export const MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_SUCCESS = 'at/panels/user/createPanel/MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_SUCCESS'
export const MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_FAILURE = 'at/panels/user/createPanel/MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_FAILURE'



// WEBPACK FOOTER //
// ./web/js/panels/user/userData/actionTypes.js